module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Giro Kalender ")]), _vm._v(" "), _c('FullCalendar', {
    attrs: {
      "events": _vm.giroList,
      "locale": "en"
    },
    on: {
      "changeMonth": _vm.changeMonth,
      "eventClick": _vm.eventClick,
      "dayClick": _vm.dayClick,
      "moreClick": _vm.moreClick
    }
  })], 1), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.isModalDetail),
      callback: function($$v) {
        _vm.isModalDetail = $$v
      },
      expression: "isModalDetail"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detail")])], 1), _vm._v(" "), _c('Form', [_c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [(_vm.isMarking) ? _c('FormItem', {
    attrs: {
      "label": "Marking"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.marking),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "marking", $$v)
      },
      expression: "dataDetail.marking"
    }
  })], 1) : _c('FormItem', {
    attrs: {
      "label": "Marking Group"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.markingGroup),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "markingGroup", $$v)
      },
      expression: "dataDetail.markingGroup"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11",
      "offset": "2"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Tanggal Terima Giro"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.giroDate),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "giroDate", $$v)
      },
      expression: "dataDetail.giroDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Tanggal Jatuh Tempo"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "paymentDate", $$v)
      },
      expression: "dataDetail.paymentDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11",
      "offset": "2"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Tanggal Mundur"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.dueDate),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "dueDate", $$v)
      },
      expression: "dataDetail.dueDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Nomor Giro"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.giroNumber),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "giroNumber", $$v)
      },
      expression: "dataDetail.giroNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11",
      "offset": "2"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Nominal Giro"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.giroNominal),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "giroNominal", $$v)
      },
      expression: "dataDetail.giroNominal"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Kliring"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.isClearing),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "isClearing", $$v)
      },
      expression: "dataDetail.isClearing"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11",
      "offset": "2"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "Dibatalkan"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.isCancel),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "isCancel", $$v)
      },
      expression: "dataDetail.isCancel"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Bank"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.dataDetail.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.dataDetail, "bankAccount", $$v)
      },
      expression: "dataDetail.bankAccount"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754fbbd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroCalendar.vue
// module id = 1832
// module chunks = 1